(function ($) {

    toggleVideoHeroPlayPause = function() {

        var heroVideo = document.getElementById('hero-video');

        if (heroVideo != null)
        {

            var playPauseButton = document.getElementById("video-hero-play-pause-button");

            if (!heroVideo.paused)
            {

                // Pause the video and set the play/pause control view state to "play."
                heroVideo.pause();
                if (playPauseButton != null)
                {
                    $(playPauseButton).children("img").attr("src", "/images/play-blue-circle-white.png");
                    $(playPauseButton).children("img").attr("alt", "play video");
                }

            }
            else
            {

                // Play the video and set the play/pause control view state to "pause."
                heroVideo.play();
                if (playPauseButton != null)
                {
                    $(playPauseButton).children("img").attr("src", "/images/pause-blue-circle-white.png");
                    $(playPauseButton).children("img").attr("alt", "pause video");
                }

            }

        }

    }

    $(function () {
        var heroVideo = document.getElementById('hero-video');

        //if (heroVideo != null) {
            //heroVideo.preload = "auto";
            //heroVideo.loop = "true";
        //}

        if (heroVideo != null) {
            //heroVideo.play();
            toggleVideoHeroPlayPause();
            /*//
            setTimeout(
                function () {
                    $(".hero-caption-wrap").fadeOut(1000, function () {
                        $(".hero-secondary-caption-wrap").fadeIn(1000);
                    });
                },
                5000
            );
            //*/
        }

        var $explore = $('#explore'),
            $window = $(window);

        $explore.addAccess();

        $explore.animateScroll({
            scrollToEl: $('#content'),
            offset: [
              { minWidth: 1200, offsetSize: 52 }
            ]
        });

        $window.on('scroll.exploreHide', function () {
            if ($window.scrollTop() > 40) {
                $explore.animate({
                    bottom: "-100%"
                }, 1000, function () {
                    $explore.hide();
                });
                $window.off('scroll.exploreHide');
            }
        });

    });
})($JQ);
